import React from 'react';

const PageId = ({id}) => (
    <>
        <span id={`page-anchor-${id.replace(/\W/g, '_')}`} className="page-id badge badge-primary">{id}</span>
    </>
);

export default PageId;
